export const BLACKLIST_PHONE_EDIT = ['+12487588857', '+12483026074'];
export const ACCEPTED_FILE_TYPES = ['image/*', 'application/pdf'];
